// SCSS entry file
import '../_scss/main.scss';
import 'babel-polyfill';
import './cookie-script-localstorage';

import { App } from './app';



// WEBPACK FOOTER //
// ./assets/_js/main.js